export function ngModelCopy(target: any, source: any): any {
  for (const i in source) {
    target[i] = source[i];
  }
}
